module.exports = __webpack_public_path__ + "static/media/Fox.15a560d0.png";